import React, {useState} from 'react';

import type {AriaMenuItem} from '../AriaMenu/AriaMenu.types';
import type {ButtonProps} from '../../elements/Button/Button';
import {Button} from '../../elements/Button/Button';
import {TestId} from '../../../utils/testIds';
import {AriaMenu} from '../AriaMenu/AriaMenu';
import {Icon, IconTypes} from '../../elements/Icon/Icon';

export const ThreeColumnSelector: React.FC<
    ButtonProps & {
        isDisabled?: boolean;
        columnLabels: string[];
        activeColumn: number;
        buttonAriaLabel?: string;
        onColumnChange: (column: number) => void;
    }
> = ({
    activeColumn,
    columnLabels,
    isDisabled,
    className,
    buttonAriaLabel = 'Toggle three column selector',
    onColumnChange,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const menuItems: AriaMenuItem[] = columnLabels.map((label, index) => ({
        key: `column-${index + 1}`,
        isActive: activeColumn === index + 1,
        label,
        onItemClick: () =>
            activeColumn !== index + 1 && onColumnChange(index + 1),
        closeMenuOnItemClick: true,
    }));

    return (
        <AriaMenu
            onOpenChange={setIsOpen}
            items={menuItems}
            button={
                <Button
                    className={className}
                    isActive={isOpen}
                    enhancerStart={<Icon source={IconTypes.IconColumns} />}
                    noEnhancerPadding
                    isDisabled={isDisabled}
                    aria-label={buttonAriaLabel}
                    size="small"
                    variant="transparent"
                    modifier="square"
                    data-testid={TestId.ButtonThreeColumnSelector}
                />
            }
            popoverPlacement="bottom right"
        />
    );
};
